<template>
    <div class="company-info">
        <div class="company-info-title">
            {{obj.company.companyname}}
        </div>

        <div class="name-pad_img-box">
            <img v-if="null != imgUrl" :src="imgUrl">
        </div>

        <div class="shop-info">
            <div>
                <span tkey="展臺位置">{{i18n.tkey("lang_booth_position")}}</span>：{{obj.addinfo1}}-{{obj.addinfo2}}
            </div>

            <div>
                <el-button type="primary" text @click="goShopEvent" tkey="前往展臺">{{i18n.tkey("lang_go_booth")}}</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>

    import {inject, computed} from "vue";

    const emits = defineEmits(['click-go-shop'])
    const props = defineProps(['obj'])

    const i18n = inject("i18n")

    const { phoneGoFloorCallback } = inject('threeHallFunc', { phoneGoFloorCallback: () => {} })

    const imgUrl = computed(() => {
        let url = null

        if (null != props.obj && null != props.obj.addinfo12){
            const json = JSON.parse(props.obj.addinfo12)

            if(null != json.img0){
                url = json.img0
            }
        }

        return url
    })

    function goShopEvent() {
        phoneGoFloorCallback(props.obj.addinfo1, props.obj.addinfo2)
        emits("click-go-shop", props.obj.addinfo1, props.obj.addinfo2)
    }
</script>

<style scoped>
    .company-info {
        //border-bottom: 1px #d9d9d9 solid;
        line-height: 2;
        //padding-top: 10px;
        //padding-bottom: 10px;
        border: 1px #DCDFE6 solid;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px;
    }

    .company-info:nth-child(even) {
        background: #f9f9f9;
    }

    .company-info-title {
        text-align: left;
        font-weight: 600;
    }

    .shop-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .name-pad_img-box{
        width: 100%;
        padding-top: 20%;
        position: relative;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .name-pad_img-box img{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: fill;
    }
</style>